import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import { EmailInput, Icon, Item, SelectInput } from 'tacho-ui';
import { defaultUserModel, UsersModel } from '../../../core/domainModels/users/UsersModel';
import { ApplicationState } from '../../../state/ApplicationState';
import { DispatchType } from '../../../state/configureStore';
import { fetchUsersThunk, updateUserThunk } from '../../../state/users/reducer';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';

interface UpdateUserModalProps {
    isOpen: boolean;
    user: UsersModel;
    onToggle: () => void;
}
export const UpdateUserModal = (props: UpdateUserModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [userData, setUserData] = useState<UsersModel>(props.user || defaultUserModel);
    const onSubmit = () => {
        dispatch(updateUserThunk(userData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchUsersThunk());
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const updateUserPending = useSelector((state: ApplicationState) => state.users.updateUsersPending);
    const updateUserError = useSelector((state: ApplicationState) => state.users.updateUsersError);
    const availableRoles = useSelector((state: ApplicationState) => state.roles.roles);
    const rolesOptions = useMemo(
        (): Array<Item> => availableRoles.map(item => ({ id: item.id.toString(), label: formatMessage({ id: item.name }) })),
        [availableRoles],
    );
    useEffect(() => {
        setUserData(props.user);
    }, [props.isOpen]);

    return (
        <TachoModal
            size={'md'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setUserData(defaultUserModel);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="usersUpdateUser" icon={Icon.User} />}
            submitLabelToTranslate="commonUpdate"
            submitIcon={Icon.Edit}
            isPending={updateUserPending}
            errorToTranslate={updateUserError}
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <EmailInput
                        label={formatMessage({ id: 'usersEmail' })}
                        value={userData?.email}
                        onChange={value => setUserData({ ...userData, email: value })}
                    />
                </Row>
                <Row>
                    <SelectInput
                        label={formatMessage({ id: 'usersRole' })}
                        value={rolesOptions.find(item => parseInt(item.id) === userData?.roleId)?.label || 1}
                        onChange={value => setUserData({ ...userData, roleId: parseInt((value as Item).id) })}
                        options={rolesOptions}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
